export default {
  AU: 'AU',
  CA: 'CA',
  MX: 'MX',
  NZ: 'NZ',
  US: 'US',
  WW: 'WW',
};
